import { Seo } from '../lib/seo';
import { container, btnPrimary, btnOutline } from '../lib/ui';
import { AppLink } from './AppLink';
import { Icon } from './Icon';

/** 404 content. Also rendered by detail pages when the slug doesn't exist. */
export function NotFoundContent() {
  return (
    <section className="bg-surface-cream">
      <Seo
        title="Page Not Found"
        description="The page you were looking for has moved or no longer exists. Explore Green Valley Interiors' services, portfolio and journal, or contact our Nagercoil studio."
        keywords={['Green Valley Interiors page not found']}
        path="/404"
        noindex
      />
      <div className={`${container} py-28 md:py-36 flex flex-col items-center text-center gap-space-md`}>
        <span className="font-label-md text-label-md uppercase tracking-[0.2em] text-secondary">Error 404</span>
        <h1 className="font-headline-xl text-headline-xl-mobile md:text-headline-xl text-primary">Page Not Found</h1>
        <p className="font-body-lg text-body-lg text-on-surface-variant max-w-xl">
          This room seems to have been redesigned. The page may have moved, or the link may be out of date.
        </p>
        <div className="flex flex-wrap justify-center gap-space-md pt-space-sm">
          <AppLink href="/" className={btnPrimary}>
            <Icon name="arrow_back" size={18} /> Back to Home
          </AppLink>
          <AppLink href="/portfolio" className={btnOutline}>
            View Portfolio
          </AppLink>
          <AppLink href="/contact" className={btnOutline}>
            Contact Us
          </AppLink>
        </div>
      </div>
    </section>
  );
}
